<template>
  
  <h1>Promoções</h1>

  <v-container class="pa-0">
    <v-row>
      <v-col cols="12">

        <img class="w-100 rounded-lg mb-4" v-if="imagem !== false" :src="imagem" />      

        <v-sheet id="promotion-body" class="bg-white rounded-lg pa-5">

          <h2 class="text-left mb-4">{{ promo.title }}</h2>

          <p class="caption">{{ promo.updated }}</p>

          <v-divider></v-divider>

          <div class="texto my-5">
            <p class="text-center text-black my-4">
              <v-icon v-if="promo.has_ended" class="mr-1">mdi-alarm-off</v-icon>
              <v-icon v-else class="mr-1">mdi-alarm</v-icon>
              Esta promoção {{ promo.has_ended ? 'encerrou' : 'encerra'}} em {{ promo.ends_at }}
            </p>

            <v-divider></v-divider>

            <div class="promo-texto pa-5" v-html="promo.text"></div>

            <v-divider></v-divider>

            <div v-if="promo.has_ended" class="py-4">
              <div v-if="promo.was_drawn && promo.winners.length > 0">
                <p class="text-center">Os ganhadores foram:</p>
                <p class="text-center">
                  <span v-for="(winner, index) of promo.winners" :key="index">{{ winner }}<br /></span>
                </p>
              </div>
              <p class="text-center" v-else>Em breve divulgaremos os ganhadores</p>
            </div>
            <div v-else-if="store.customer.isLoggedIn && !store.customer.isExpired" class="py-4 text-center">
              <v-btn
                v-if="!participantes.includes(store.customer.id)"
                @click="participar(promo.uuid)"
                :disabled="isJoining"
                class="bg-amber-darken-1 align-self-center"
                rounded
                variant="flat"
              >
                <v-progress-circular v-if="isJoining" indeterminate color="black" class="align-self-center mr-2"></v-progress-circular>
                QUERO PARTICIPAR
              </v-btn>
              <p v-else class="text-center text-green">
                <v-icon class="mr-1">mdi-check-bold</v-icon>
                Você está participando desta promoção!
              </p>
            </div>
            <p v-else class="text-center py-4"><router-link to="/facaparte">Associe-se</router-link> ou <a href="/#login">faça login</a> para participar!</p>
          </div>

        </v-sheet>

      </v-col>
    </v-row>
  </v-container>



</template>

<script setup>
  import { inject, onMounted, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useDisplay } from 'vuetify';
  import { useStore } from '@/stores';

  const axios = inject('axios');
  const backendUrl = inject('backendUrl');
  const promo = ref([]);
  const participantes = ref([]);
  const route = useRoute();
  const { xs } = useDisplay();
  const store = useStore();
  const imagem = ref(false);
  const gallery = ref({});
  const isJoining = ref(false);

  const participar = (uuid) => {
    if(participantes.value.includes(store.customer.id)) {
      alert('Você já está participando desta promoção');
      return false;
    }
    isJoining.value = true;
    axios.get(
      backendUrl + `/promotion/join/` + uuid,
    ).then((response) => {
      isJoining.value = false;
      if(response.data.success) {
        participantes.value.push(store.customer.id);
      } else {
        alert(response.data.error);
      }
    });
  }


  onMounted(() => {
    axios.get(backendUrl + '/promotions/' + route.params.uuid).then((response) => {
      promo.value = response.data;
      console.log(promo.value)
      imagem.value = xs.value?response.data.image2:response.data.image1;
      participantes.value = response.data.participants_ids;
    });
  })
</script>

<style lang="scss" scoped>
  
  #promotion-body:deep(ol), #promotion-body:deep(ul) {
    color: gray;
    padding: 10px 30px;
  }


</style>
